var _a;
import { vehicleSpecificationApi } from "./vehicleSpecificationApi";
export var reducers = (_a = {},
    _a[vehicleSpecificationApi.reducerPath] = vehicleSpecificationApi.reducer,
    _a);
export var middleware = [vehicleSpecificationApi.middleware];
